module.exports = __webpack_public_path__ + "static/summer_bottom-971389a28374f2962b0979a371c7bc7f.png";